(function () {
  if (window.woProductBuyZoneBound) return;
  window.woProductBuyZoneBound = true;
  const articleSelector = 'article.wo-product-enhanced[data-form-id][data-product-id]';
  const controlSelector = '.f8pr-variant-selection input[type="radio"], .f8pr-variant-selection select';
  const selectionKeys = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', ' ', 'Enter', 'Home', 'End'];
  let keyboardSelection = null;
  let pending = null;
  let expiry = null;

  function isOption(control) {
    return control instanceof Element && control.matches(controlSelector) && (control.name === 'variant-id' || control.name.startsWith('options[')) && Boolean(control.closest(articleSelector));
  }

  function clearPending() {
    pending = null;
    keyboardSelection = null;
    if (expiry) window.clearTimeout(expiry);
    expiry = null;
  }

  document.addEventListener('pointerdown', clearPending, true);
  window.addEventListener('blur', clearPending);
  document.addEventListener('keydown', function (event) {
    clearPending();
    if (isOption(event.target) && selectionKeys.includes(event.key)) {
      keyboardSelection = { article: event.target.closest(articleSelector), name: event.target.name };
    }
  }, true);

  document.addEventListener('change', function (event) {
    const control = event.target;
    if (!keyboardSelection || !isOption(control) || control.name !== keyboardSelection.name || control.closest(articleSelector) !== keyboardSelection.article || document.activeElement !== control) return;
    if (expiry) window.clearTimeout(expiry);
    const article = keyboardSelection.article;
    pending = {
      id: control.id,
      name: control.name,
      value: control.value,
      tag: control.tagName,
      node: control,
      article: article,
      productId: article.dataset.productId,
      sectionId: article.dataset.template,
      formId: article.dataset.formId
    };
    keyboardSelection = null;
    expiry = window.setTimeout(clearPending, 10000);
  }, true);

  document.addEventListener('focusin', function (event) {
    if (pending && event.target !== pending.node && event.target !== document.body) clearPending();
  }, true);
  document.addEventListener('shopify:section:unload', function (event) {
    if (pending && event.target instanceof Element && event.target.contains(pending.article)) clearPending();
  });

  new MutationObserver(function () {
    if (!pending || pending.node.isConnected) return;
    if (!document.hasFocus() || (document.activeElement !== document.body && document.activeElement !== document.documentElement)) {
      clearPending();
      return;
    }
    const article = Array.from(document.querySelectorAll(articleSelector)).find(function (item) {
      return item.dataset.productId === pending.productId && item.dataset.template === pending.sectionId && item.dataset.formId === pending.formId;
    });
    if (!article) return;
    const controls = Array.from(article.querySelectorAll(controlSelector)).filter(function (control) {
      return isOption(control) && control.tagName === pending.tag && control.name === pending.name && control.value === pending.value && !control.disabled && (control.tagName === 'SELECT' || control.checked);
    });
    const replacement = controls.find(function (control) { return control.id === pending.id; }) || controls[0];
    if (!replacement) return;
    replacement.focus({ preventScroll: true });
    clearPending();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
